import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Right from "./Right";
import { scrollToTop } from "../util/helpers";
import styles from "../styles/Layout.module.scss";
import { useSelector } from "react-redux";

const Layout = ({ children }) => {
  const { location, prevLocation } = useSelector((state) => state.pagedata);

  useEffect(() => {
    window["nitroAds"] = window["nitroAds"] || {
      createAd: function() {
        window.nitroAds.queue.push(["createAd", arguments]);
      },
      queue: [],
    };
    scrollToTop();
  }, []);

  useEffect(() => {
    if (location !== prevLocation && !location.state?.noTop) {
      scrollToTop();
    }
  }, [location, prevLocation]);

  return (
    <div className={styles.container}>
      <div className={styles.left}>{children}</div>
      <Right />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default Layout;
